export type Period =
  | "currentMonth"
  | "previousMonth"
  | "currentYear"
  | "previousYear"
  | "custom";

export interface Range {
  startIso: string;
  endIso: string;
  granularity: "day" | "month";
}

export function rangeFor(period: Period, customStart: string, customEnd: string): Range {
  const now = new Date();
  const y = now.getUTCFullYear();
  const m = now.getUTCMonth();
  const iso = (d: Date) => d.toISOString();
  switch (period) {
    case "currentMonth":
      return { startIso: iso(new Date(Date.UTC(y, m, 1))), endIso: iso(now), granularity: "day" };
    case "previousMonth":
      return {
        startIso: iso(new Date(Date.UTC(y, m - 1, 1))),
        endIso: iso(new Date(Date.UTC(y, m, 0, 23, 59, 59))),
        granularity: "day",
      };
    case "currentYear":
      return { startIso: iso(new Date(Date.UTC(y, 0, 1))), endIso: iso(now), granularity: "month" };
    case "previousYear":
      return {
        startIso: iso(new Date(Date.UTC(y - 1, 0, 1))),
        endIso: iso(new Date(Date.UTC(y - 1, 11, 31, 23, 59, 59))),
        granularity: "month",
      };
    case "custom":
      return {
        startIso: new Date(`${customStart}T00:00:00.000Z`).toISOString(),
        endIso: new Date(`${customEnd}T23:59:59.999Z`).toISOString(),
        granularity: "day",
      };
  }
}
